﻿import { Injectable, Injector } from '@angular/core';
import { BillOfMaterialRepository } from 'src/app/repositories/productions-repository/bill-of-material-repository/BillOfMaterialRepository';
import { MaterialDemageRepository } from 'src/app/repositories/productions-repository/material-demage-repository/MaterialDemageRepository';
import { MaterialReceiptRefundRepository } from 'src/app/repositories/productions-repository/material-receipt-refund-repository/MaterialReceiptRefundRepository';
import { MaterialReceiptRepository } from 'src/app/repositories/productions-repository/material-receipt-repository/MaterialReceiptRepository';
import { ProductionPostingSetupRepository } from 'src/app/repositories/productions-repository/production-posting-setup-repository/ProductionPostingSetupRepository';
import { ProductionReceiptRefundRepository } from 'src/app/repositories/productions-repository/production-receipt-refund-repository/ProductionReceiptRefundRepository';
import { ProductionReceiptRepository } from 'src/app/repositories/productions-repository/production-receipt-repository/ProductionReceiptRepository';
import { ResourceCostRepository } from 'src/app/repositories/productions-repository/resource-cost-repository/ResourceCostRepository';
import { ResourceMasterRepository } from 'src/app/repositories/productions-repository/resource-master-repository/ResourceMasterRepository';
import { ResourceUOMRepository } from 'src/app/repositories/productions-repository/ResourceUOMRepository';
import { RoutingRepository } from 'src/app/repositories/productions-repository/routing-repository/RoutingRepository';
import { WasteManagementRepository } from 'src/app/repositories/productions-repository/waste-management-repository/WasteManagementRepository';
import { WorkCenterRepository } from 'src/app/repositories/productions-repository/work-center-repository/WorkCenterRepository';
import { ProductionRepository } from '../../repositories/productions-repository/production-repository/ProductionRepository';
import { MarketCategoryRepository } from 'src/app/repositories/productions-repository/marketCategory-repository/MarketCategoryRepository';
import { ShedRepository } from 'src/app/repositories/productions-repository/shed-repository/ShedRepository';
import { MachinesRepository } from 'src/app/repositories/productions-repository/machines-repository/MachinesRepository';
import { CompaniesRepository } from 'src/app/repositories/productions-repository/companies-repository/CompaniesRepository';
import { ProductShedMappingRepository } from 'src/app/repositories/productions-repository/productShedMapping-repository/ProductShedMappingRepository';
import { ProductionEntryRepository } from 'src/app/repositories/productions-repository/productionEntry-repository/ProductionEntryRepository';
import { ProductionSessionRepository } from 'src/app/repositories/productions-repository/productionSession-repository/ProductionSessionRepository';
import { ProductRepository } from 'src/app/repositories/productions-repository/products-repository/ProductRepository';
import { ProductionDashboardRepository } from 'src/app/repositories/productions-repository/productionDashboard-repository/ProductionDashboardRepository';

@Injectable({
    providedIn: 'root'
})
export class ProductionBusinessService {

    constructor(private injector: Injector) { }

    private resourceUOMRepository: ResourceUOMRepository;
    public get resourceUOMService(): ResourceUOMRepository {
        if (!this.resourceUOMRepository) {
            this.resourceUOMRepository = this.injector.get(ResourceUOMRepository);
        }
        return this.resourceUOMRepository;
    }

    private resourceMasterRepository: ResourceMasterRepository;
    public get resourceMasterService(): ResourceMasterRepository {
        if (!this.resourceMasterRepository) {
            this.resourceMasterRepository = this.injector.get(ResourceMasterRepository);
        }
        return this.resourceMasterRepository;
    }

    private workCenterRepository: WorkCenterRepository;
    public get workCenterService(): WorkCenterRepository {
        if (!this.workCenterRepository) {
            this.workCenterRepository = this.injector.get(WorkCenterRepository);
        }
        return this.workCenterRepository;
    }

    private materialDemageRepository: MaterialDemageRepository;
    public get materialDemageService(): MaterialDemageRepository {
        if (!this.materialDemageRepository) {
            this.materialDemageRepository = this.injector.get(MaterialDemageRepository);
        }
        return this.materialDemageRepository;
    }

    private wasteManagementRepository: WasteManagementRepository;
    public get wasteManagementService(): WasteManagementRepository {
        if (!this.wasteManagementRepository) {
            this.wasteManagementRepository = this.injector.get(WasteManagementRepository);
        }
        return this.wasteManagementRepository;
    }

    private materialReceiptRepository: MaterialReceiptRepository;
    public get materialReceiptService(): MaterialReceiptRepository {
        if (!this.materialReceiptRepository) {
            this.materialReceiptRepository = this.injector.get(MaterialReceiptRepository);
        }
        return this.materialReceiptRepository;
    }


    private materialReceiptRefundRepository: MaterialReceiptRefundRepository;
    public get materialReceiptRefundService(): MaterialReceiptRefundRepository {
        if (!this.materialReceiptRefundRepository) {
            this.materialReceiptRefundRepository = this.injector.get(MaterialReceiptRefundRepository);
        }
        return this.materialReceiptRefundRepository;
    }

    private productionReceiptRefundRepository: ProductionReceiptRefundRepository;
    public get productionReceiptRefundService(): ProductionReceiptRefundRepository {
        if (!this.productionReceiptRefundRepository) {
            this.productionReceiptRefundRepository = this.injector.get(ProductionReceiptRefundRepository);
        }
        return this.productionReceiptRefundRepository;
    }

    private productionReceiptRepository: ProductionReceiptRepository;
    public get productionReceiptService(): ProductionReceiptRepository {
        if (!this.productionReceiptRepository) {
            this.productionReceiptRepository = this.injector.get(ProductionReceiptRepository);
        }
        return this.productionReceiptRepository;
    }

    private routingRepository: RoutingRepository;
    public get routingService(): RoutingRepository {
        if (!this.routingRepository) {
            this.routingRepository = this.injector.get(RoutingRepository);
        }
        return this.routingRepository;
    }

    private resourceCostRepository: ResourceCostRepository;
    public get resourceCostService(): ResourceCostRepository {
        if (!this.resourceCostRepository) {
            this.resourceCostRepository = this.injector.get(ResourceCostRepository);
        }
        return this.resourceCostRepository;
    }

    private billOfMaterialRepository: BillOfMaterialRepository;
    public get billOfMaterialService(): BillOfMaterialRepository {
        if (!this.billOfMaterialRepository) {
            this.billOfMaterialRepository = this.injector.get(BillOfMaterialRepository);
        }
        return this.billOfMaterialRepository;
    }

    private productionRepository: ProductionRepository;
    public get productionService(): ProductionRepository {
        if (!this.productionRepository) {
            this.productionRepository = this.injector.get(ProductionRepository);
        }
        return this.productionRepository;
    }

    private productionPostingSetupRepository: ProductionPostingSetupRepository;
    public get productionPostingSetupService(): ProductionPostingSetupRepository {
        if (!this.productionPostingSetupRepository) {
            this.productionPostingSetupRepository = this.injector.get(ProductionPostingSetupRepository);
        }
        return this.productionPostingSetupRepository;
    }

    private marketCategoryRepository: MarketCategoryRepository;
    public get marketCategoryService(): MarketCategoryRepository {
        if (!this.marketCategoryRepository) {
            this.marketCategoryRepository = this.injector.get(MarketCategoryRepository);
        }
        return this.marketCategoryRepository;
    }

    private shedRepository: ShedRepository;

    public get shedService(): ShedRepository {
        if (!this.shedRepository) {
            this.shedRepository = this.injector.get(ShedRepository);
        }
        return this.shedRepository;
    }

    private machinesRepository: MachinesRepository;

    public get machinesService(): MachinesRepository {
        if (!this.machinesRepository) {
            this.machinesRepository = this.injector.get(MachinesRepository);
        }
        return this.machinesRepository;
    }

    private companiesRepository: CompaniesRepository;

    public get companiesService(): CompaniesRepository {
        if (!this.companiesRepository) {
            this.companiesRepository = this.injector.get(CompaniesRepository);
        }
        return this.companiesRepository;
    }

    private productShedMappingRepository: ProductShedMappingRepository;

    public get productShedMappingService(): ProductShedMappingRepository {
        if (!this.productShedMappingRepository) {
            this.productShedMappingRepository = this.injector.get(ProductShedMappingRepository);
        }
        return this.productShedMappingRepository;
    }

    private productionEntryRepository: ProductionEntryRepository;

    public get productionEntryService(): ProductionEntryRepository {
        if (!this.productionEntryRepository) {
            this.productionEntryRepository = this.injector.get(ProductionEntryRepository);
        }
        return this.productionEntryRepository;
    }

    private productRepository: ProductRepository;

    public get productService(): ProductRepository {
        if (!this.productRepository) {
            this.productRepository = this.injector.get(ProductRepository);
        }
        return this.productRepository;
    }

    private productionSessionRepository: ProductionSessionRepository;

    public get productionSessionService(): ProductionSessionRepository {
        if (!this.productionSessionRepository) {
            this.productionSessionRepository = this.injector.get(ProductionSessionRepository);
        }
        return this.productionSessionRepository;
    }

      private productionDashboardRepository: ProductionDashboardRepository;
    public get productionDashboardService(): ProductionDashboardRepository {
        if (!this.productionDashboardRepository) {
            this.productionDashboardRepository = this.injector.get(ProductionDashboardRepository);
        }
        return this.productionDashboardRepository;
    }
}

